import { Loader } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";

import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import { Label } from "@components/ui/label";
import { useState } from "react";
import { useMutation } from "react-query";
import React from "react";
import { anomalyFixed } from "@services/api/amlAnomalyDetection";
import { useToast } from "@components/ui/use-toast";

interface AMLDropdownmenuProps {
  anomalyData?: { anomalyId: number; time: number }[];
  anomalyId?: number;
  time?: number;
  action: string;
  anomalyType: string;
  show: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  header?: string;
}

const AnomalyFixedDialog: React.FC<AMLDropdownmenuProps> = ({
  anomalyData = [],
  anomalyId,
  time,
  action,
  anomalyType,
  show,
  onClose,
  onSuccess,
  header,
}) => {
  const { toast } = useToast();
  const [fixedReason, setFixedReason] = useState("");
  const [fixedNote, setFixedNote] = useState("");

  const [fixalertLoader, setfixalertLoader] = useState(false);

  const watchAnomalyFixedMutation = useMutation(anomalyFixed, {
    onSuccess: () => {
      setfixalertLoader(false);
      toast({
        title: "Success",
        description: action == "fixanomaly" ? "Anomaly fixed" : "Alert fixed",
        variant: "success",
      });
      onSuccess && onSuccess();
      onClose();
    },
    onError: () => {
      setfixalertLoader(false);
      toast({
        title: "Error",
        description: "An error occured!",
        variant: "destructive",
      });
    },
  });

  function submitAnomalyFixed() {
    setfixalertLoader(true);

    let adata = `[{ "id": ${anomalyId}, "time": ${time} }]`;
    if (anomalyData.length > 0) {
      const temp: any = [];
      anomalyData.forEach((item) => {
        temp.push({
          id: item.anomalyId,
          time: item.time,
        });
      });
      adata = JSON.stringify(temp);
    }

    watchAnomalyFixedMutation.mutate({
      anomalyReason: fixedReason,
      actionNote: fixedNote,
      action: action,
      anomalyType: anomalyType,
      anomalyIDs: adata,
    });
  }

  return (
    <>
      <Dialog open={show} onOpenChange={onClose}>
        <DialogContent
          className="sm:max-w-[425px]"
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle>
              {header ||
                (action.includes("alert") ? "Fix Alert" : "Fix Anomaly")}
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="fixedAnomalyReason" className="text-right">
                Reason
              </Label>
              <Select
                value={fixedReason}
                onValueChange={(it) => setFixedReason(it)}
              >
                <SelectTrigger className="col-span-3">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="False Positive">
                      False Positive
                    </SelectItem>
                    <SelectItem value="True Positive">True Positive</SelectItem>
                    <SelectItem value="Other">Other</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="fixedAnomalyNote" className="text-right">
                Note
              </Label>
              <Input
                id="fixedAnomalyNote"
                value={fixedNote}
                onChange={(e) => setFixedNote(e.target.value)}
                className="col-span-3"
              />
            </div>
          </div>
          <DialogFooter>
            {fixalertLoader ? (
              <Button type="submit">
                <Loader className="animate-spin" />
              </Button>
            ) : (
              <Button type="submit" onClick={submitAnomalyFixed}>
                Submit
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AnomalyFixedDialog;
